<template>
    <div class="flex justify-center">
        <vs-card class="w-10/12 mt-5 shadow-lg card relative">
            <div class="flex flex-col items-center">
                <div
                    class="w-10/12 mt-10 flex flex-col items-center justify-center"
                    v-if="couponCode"
                >
                    <h2 class="mb-12 text-center">REDEEM YOUR COUPON</h2>
                </div>
                <div
                    class="w-10/12 mt-10 flex flex-col items-center justify-center"
                    v-if="couponCode"
                >
                    <h4 class="mb-5 text-center">CREATE A NEW ACCOUNT</h4>
                    <button
                        type="button"
                        class="sign-up py-6 px-10 mb-4"
                        @click="
                            $router.push({
                                name: 'redeem-register',
                                params: { couponCode: couponCode }
                            })
                        "
                    >
                        Sign Up
                    </button>
                    <h4 class="m-4 text-center">ALREADY HAVE AN ACCOUNT?</h4>
                    <p
                        class="log-in"
                        @click="
                            $router.push({
                                name: 'redeem-existing',
                                params: { couponCode: couponCode }
                            })
                        "
                    >
                        LOG IN
                    </p>
                    <br />
                    <br />
                </div>
                <div v-else class="w-10/12 mt-10 flex flex-col items-center">
                    <h2>No coupon has been found. Please check your link and try again.</h2>
                </div>

                <img
                    src="@/assets/images/koala-img.png"
                    height="200"
                    alt="Croc Image"
                    class="koala"
                />
            </div>
        </vs-card>
    </div>
</template>

<script>
import { mapParams } from '@/plugins/mappers'
import countries from '../countries'

export default {
    name: 'redemption-landing',
    computed: {
        ...mapParams({
            couponCode: 'couponCode'
        })
    },
    watch: {
        couponCode: {
            handler(val) {
                if (val) {
                    this.details.couponCode = val
                }
            },
            immediate: true
        }
    },
    components: {},
    data() {
        return {
            loading: false,
            countries: countries,
            passwordConfirm: null,
            details: {
                email: null,
                password: null,
                couponCode: null,
                firstName: null,
                countryId: 13
            }
        }
    },
    methods: {
        validate() {}
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
.koala {
    position: absolute;
    right: -10px;
    bottom: 0;
}
/* hiding image for all devices up to a device width of 740px : */
@media screen and (max-width: 740px) {
    .koala {
        display: none;
    }
}
#logo {
    background-color: #b7dcc9;
}
.margin-left {
    margin-left: -180%;
}
.card {
    border-radius: 15px;
    min-height: 425px;
    max-width: 650px;
}
h2,
h4 {
    color: rgb(124, 124, 124);
}
input {
    color: #949c9c;
}
input:focus {
    box-shadow: 0px 4px 10px -6px;
}
.border-bottom {
    border-top: none;
    border-left: none;
    border-right: none;
    border-color: #bcbdbe;
}
::placeholder {
    color: #bcbdbe;
}
.sign-up {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
    letter-spacing: 1.5px;
}
.log-in {
    cursor: pointer;
    color: #9dd6cd;
    font-size: 16px;
    font-weight: 600;
}
a {
    font-size: 1rem;
}
.error {
    color: #f72415;
}
p {
    color: #bcbdbe;
}
li {
    color: #949c9c;
    font-size: 1.2rem;
}
li span {
    font-size: 1rem;
}
@media only screen and (min-height: 1200px) {
    .height {
        height: 1202px;
    }
}
@media only screen and (max-width: 650px) {
    .croc {
        display: none;
    }
}
</style>
